import { render, staticRenderFns } from "./missing-data.vue?vue&type=template&id=114a67e3&"
import script from "./missing-data.vue?vue&type=script&lang=js&"
export * from "./missing-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/missing-data.vue
// module id = 1415
// module chunks = 0